const Modal = (id: string) => {
  const overlay = document.getElementById(id);
  const closeButtons = overlay?.querySelectorAll<HTMLButtonElement>(
    '.js-btn-modal-close',
  );
  let isModalOpen = false;

  const open = () => {
    if (overlay) {
      overlay.classList.add('active');
      document.body.style.overflow = 'hidden';
      isModalOpen = true;

      // Add event listener to overlay only if not already added
      if (!overlay.classList.contains('modal-listener-attached')) {
        overlay.addEventListener('click', handleOutsideClick);
        overlay.classList.add('modal-listener-attached');
      }
    }
  };

  const close = () => {
    if (overlay && isModalOpen) {
      overlay.classList.remove('active');
      document.body.style.overflow = '';
      isModalOpen = false;

      // Remove event listener only if present
      if (overlay.classList.contains('modal-listener-attached')) {
        console.log('Removing click listener from overlay');
        overlay.removeEventListener('click', handleOutsideClick);
        overlay.classList.remove('modal-listener-attached');
      }
    }
  };

  const handleOutsideClick = (event: MouseEvent) => {
    if (isModalOpen) {
      // Check if the click target is the overlay itself, not the child elements
      if (event.target === overlay) {
        console.log('Click outside detected');
        close();
      }
    }
  };

  closeButtons?.forEach(closeButton => {
    closeButton.addEventListener('click', close);
  });

  return {
    open,
    close,
  };
};

export default Modal;
